import { render } from "./GreenBack.svg?vue&type=template&id=99169d86"
const script = {}
script.render = render

export default script